<template>
  <div id="app">
    <header>
      <UpperHeader/>
    </header>
    <MainMenu/>
    <main>
      <router-view/>
    </main>
    <footer>
      <KlantLogos/>
    </footer>
  </div>
</template>

<script>
import UpperHeader from '@/components/UpperHeader.vue'
import MainMenu from '@/components/MainMenu.vue'
import KlantLogos from '@/components/KlantLogos.vue'

export default {
  name: 'app',
  components: {
    UpperHeader, MainMenu, KlantLogos
  },
  mounted () {
    this.$store.dispatch('getMenu', 116)
    this.$store.dispatch('teamModule/getTeam')
    this.$store.dispatch('teamModule/getMemberAnimations')
  }
}
</script>

<style lang="scss">
body {
  margin: 0;
}

#app {
  font-family: nudista-web, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: max-content minmax(80vh, 1fr) max-content auto;

  @media all and (min-width: 768px) {
    grid-template-rows: max-content max-content minmax(80vh, 1fr) auto;
  }
}

#nprogress .bar {
  background: #5c47a7 !important;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #5c47a7;
    }
  }
}
.click {
  cursor: pointer;
}
.container {
  max-width: 1024px;
  margin: 0 auto;
}
.plyr--video .plyr__controls {
  background: linear-gradient(rgba(0,0,0,0),rgba(0,0,0,.3)) !important;
}
main {
  background-color: #F0F0F0;
}
img {
  display: block;
  max-width: 100%;
}
svg {
  display: block;
}
</style>
